import React, { useEffect, useRef } from "react";
import Marquee from "react-fast-marquee";
import Typewriter from "typewriter-effect";

import {
  FaDiscord,
  FaGitAlt,
  FaGithub,
  FaGraduationCap,
  FaInstagram,
  FaLinkedin,
  FaNode,
  FaPython,
  FaReact,
  FaSchool,
  FaUniversity,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
  SiCplusplus,
  SiExpress,
  SiJavascript,
  SiMongodb,
  SiMysql,
  SiRedux,
  SiSpringboot,
  SiTailwindcss,
} from "react-icons/si";

const SocialItem = ({ icon, link }) => {
  return (
    <div className="row-span-1 my-4 flex items-center">
      <a href={link}>{icon}</a>
    </div>
  );
};

const SkillItem = ({ skill }) => {
  return <div className="py-2 px-4 text-white">{skill}</div>;
};

const QualificationItem = ({ icon, title, duration, location }) => {
  return (
    <div className="flex items-center">
      <div className="flex-shrink-0 w-8 h-8 md:w-16 md:h-16 bg-orange-200 text-orange-600 rounded-full flex items-center justify-center">
        {icon}
      </div>
      <div className="ml-2 md:ml-4">
        <h3 className="text-base md:text-2xl font-semibold">{title}</h3>
        <p className="text-sm md:text-base">
          {location} ({duration})
        </p>
      </div>
    </div>
  );
};

const WorkItem = ({ icon, title, duration, location }) => {
  return (
    <div className="flex items-center">
      <div className="flex-shrink-0 w-8 h-8 md:w-16 md:h-16 bg-orange-200 text-orange-600 rounded-full flex items-center justify-center">
        {icon}
      </div>
      <div className="ml-2 md:ml-4">
        <h3 className="text-base md:text-2xl font-semibold">{title}</h3>
        <p className="text-sm md:text-base">
          {location} ({duration})
        </p>
      </div>
    </div>
  );
};

export default function Main() {
  const options = {
    strings: ['a Final Year ECE student at PEC Chandigarh.', 'skilled in Mern Stack Development, C++, Python, and Spring Boot.', 'passionate about learning new technologies and building projects.'],
    autoStart: true,
    loop: true,
  };

  const qualifications = [
    {
      icon: <FaUniversity className="text-lg md:text-3xl" />,
      title: "B.Tech. Electronics and Communication Engineering",
      duration: "2021 - 2025",
      location: "PEC Chandigarh",
    },
    {
      icon: <FaGraduationCap className="text-lg md:text-3xl" />,
      title: "Senior Secondary Certificate",
      duration: "2020 - 2021",
      location: "Kendriya Vidyalaya, Chandigarh",
    },
    {
      icon: <FaSchool className="text-lg md:text-3xl" />,
      title: "Secondary School Certificate",
      duration: "2018 - 2019",
      location: "Kendriya Vidyalaya, Chandigarh",
    },
  ];

  const work = [
    {
      icon: <FaReact className="text-lg md:text-3xl" />,
      title: "Software Developer Intern",
      duration: "2024",
      location: "Electrowaves Electronics, Panchkula",
    },
  ];

  return (
    <div id="about" className="px-10 md:px-20 py-5 md:py-10 ">
      <div className="md:grid grid-cols-2 gap-5 md:gap-10 items-center">
        {/* left col */}
        <div className="col-span-1">
          <p className="mb-5 text-sm md:text-base">WELCOME TO MY WEBSITE</p>
          <h1 className="text-4xl md:text-6xl font-bold">👋 Hi, I'm Jatin</h1>
          <p className="text-2xl md:text-4xl">
            Web & App <span className="text-secondary">Developer</span>
          </p>
          <p className="my-2 md:my-5 text-sm md:text-lg">
            I am <span className="inline-block" ><Typewriter options={options} /></span>
          </p>
          <button
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1tFiUCzS4J-hyDDJ_6jCT78HHBciv5Lhp/view?usp=sharing",
                "_blank"
              )
            }
            className=" py-3 px-4 mt-5 text-sm md:text-base rounded-md bg-secondary text-white hover:bg-white hover:text-black font-medium duration-700 delay-100 transition-all"
          >
            Download Resume
          </button>
        </div>

        {/* right col */}
        <div className="col-span-1 grid-cols-3 hidden md:flex items-center justify-between">
          <div className="col-span-2">
            <img
              className="w-96 h-96 border-8 border-white rounded-full mt-5"
              src={require("../assets/images/profile.jpg")}
              alt="Jatin"
            />
          </div>
          {/* social */}
          <div className="col-span-1 grid grid-rows-4 gap-5 mx-10 ">
            <SocialItem
              icon={
                <FaGithub className="text-4xl text-white hover:text-secondary hover:scale-125 transition-all duration-500 delay-100" />
              }
              link="https://github.com/JatinSinghBisht01"
            />
            <SocialItem
              icon={
                <FaLinkedin className="text-4xl text-white hover:text-secondary hover:scale-125 transition-all duration-500 delay-100" />
              }
              link="https://www.linkedin.com/in/jatin-bisht-861b3b227/"
            />
            <SocialItem
              icon={
                <FaXTwitter className="text-4xl text-white hover:text-secondary hover:scale-125 transition-all duration-500 delay-100" />
              }
              link="https://x.com/JatinBisht71876"
            />
            <SocialItem
              icon={
                <FaInstagram className="text-4xl text-white hover:text-secondary hover:scale-125 transition-all duration-500 delay-100" />
              }
              link="https://instagram.com"
            />

            <SocialItem
              icon={
                <FaDiscord className="text-4xl text-white hover:text-secondary hover:scale-125 transition-all duration-500 delay-100" />
              }
              link="https://discord.com/"
            />
          </div>
        </div>
      </div>

      {/* Skills strip */}
      <Marquee
        className="mt-8 md:mt-16 mb-5 md:mb-10"
        gradient={false}
        speed={40}
      >
        <SkillItem
          skill={<SiCplusplus className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<FaPython className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiSpringboot className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiJavascript className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<FaGitAlt className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiTailwindcss className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<FaReact className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiRedux className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiExpress className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<FaNode className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiMongodb className="text-3xl md:text-5xl text-white" />}
        />
        <SkillItem
          skill={<SiMysql className="text-3xl md:text-5xl text-white" />}
        />
      </Marquee>

      {/* Academic Qualification and Work Experience */}
      <div className="md:grid grid-cols-2 my-10 justify-items-center">
        {/* Academic Qualification */}
        <div className="col-span-1">
          <h2 className="text-2xl md:text-4xl font-bold mt-10 mb-5">
            Academic <span className="text-orange-400">Qualification</span>
          </h2>
          <div className="space-y-4 md:space-y-8">
            {qualifications.map((qualification, index) => (
              <QualificationItem key={index} {...qualification} />
            ))}
          </div>
        </div>

        {/* Work Experience */}
        <div className="col-span-1">
          <h2 className="text-2xl md:text-4xl font-bold mt-10 mb-5">
            Work <span className="text-orange-400">Experience</span>
          </h2>
          <div className="space-y-4 md:space-y-8">
            {work.map((work, index) => (
              <WorkItem key={index} {...work} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
